<template>
    <div class="memberList">
        <v-card class="cardWrap">
            <CardTitle title="随時連絡事項設定" />
            <v-form ref="form" lazy-validation v-if="golfCount" @submit.prevent>
                <v-toolbar flat color="white" class="mt-1">
                    <v-select
                        class="mr-3 pt-4"
                        :items="golfSelect"
                        item-value="golf_code"
                        item-text="golf_name"
                        v-model="golf_code"
                        label="ゴルフ場名"
                    ></v-select>
                    <v-btn
                        color="primary"
                        class="ml-5"
                        v-on:click="clickSearch"
                        :disabled="btn[3].isActive"
                        >検索</v-btn>
                    <v-spacer></v-spacer>
                </v-toolbar>
            </v-form>
            <v-data-table
                :headers="headers"
                :items="desserts"
                hide-default-footer
                class="elevation-1">
                <template v-slot:top>
                </template>
                <template v-slot:[`item.delivery_flag_name`]="{ item }">
                    <label v-if="item.delivery_flag==0">配信済み</label>
                </template>
                <template v-slot:[`item.editBtn`]="{ item }">
                    <v-btn color="green darken-4" text @click="OnEditModal(item)" class="editBtn" :disabled="btn[0].isActive">変更</v-btn>
                </template>
                <template v-slot:[`item.deleteBtn`]="{ item }">
                    <v-btn color="green darken-4" text @click="OnDeleteModal(item)" class="editBtn" :disabled="btn[1].isActive">削除</v-btn>
                </template>
            </v-data-table>
            <v-pagination
                class="my-2"
                v-model="page"
                :length="pageCount"
                :total-visible="7"
                @input="clickPagination"
            ></v-pagination>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-4" text @click="OnAddModal()" :disabled="btn[2].isActive">追加</v-btn>
            </v-card-actions>
        </v-card>
        <MessageModal
        ref="MessageModal" v-on:from-Dialog="OnCloseEditModal" :golfCode="golf_code"
        />
        <RemoveOverlay
            page-name="随時連絡事項"
            @processing="deleteMessage"
            @cancel="deleteOverlay = !deleteOverlay"
            :process-result="process"
            :OverlaySwitch="deleteOverlay"
        />
    </div>
</template>

<script>
import CardTitle from '../../components/module/CardTitle';
import MessageModal from './modal/MessageModal';
import RemoveOverlay from '@/components/overlay/RemoveOverlay';
import validater from '@/lib/validater';

import { MEMBER_LIST_INITIAL_DISPLAY } from '../../constants/member_list';
import { GET_MESSAGE_DELIVERY_LIST, DELETE_MESSAGE_DELIVERY } from '@/constants/delivery_message';
import { authorityMixin } from '@/views/authorityMixin';
import { utilityMixin } from '@/mixins/utility';
import { GET_OPERATION_ACCESSES_LIST } from '@/constants/operation_accesses';
import { GET_LOGIN_ADMIN } from '@/constants/login';
import { GET_CODE_LIST } from '@/constants/codelist';

export default {
    components: {
        CardTitle,
        MessageModal,
        RemoveOverlay
    },
    mixins: [
        authorityMixin,
        utilityMixin
    ],
    data () {
        return {
            page: 1,
            pageCount: 0,
            begin_row: 0,
            limit_rows: 10,
            Itemlist: [],
            // データテーブルに渡す値
            desserts: [],
            // データテーブルの見出し要素
            headers: [
                { text: '配信日', sortable: false, value: 'delivery_date' },
                { text: '', sortable: false, value: 'delivery_flag_name' },
                { text: '本文', align: 'left', sortable: false, value: 'delivery_caption' },
                { text: '', value: 'editBtn', sortable: false },
                { text: '', value: 'deleteBtn', sortable: false }
            ],
            // 区分選択のセレクトエリアの表示値
            golf_groups: [],
            // ゴルフ場選択の制御
            modeStatus: '',
            golf_code: null,
            golfCount: 0,
            golfSelect: [],
            process: {
                result: '',
                resultText: '',
                btnDisabled: 0
            },
            editOverlay: false,
            deleteOverlay: false,
            // ダイアログに渡すデータ
            fromSetData: {
                id: ''
            },
            // ログインしている者の情報
            admin: {
                golf_code: '',
                user_div: '',
                user_id: '',
                point_use_type: ''
            },
            // ボタンの活性・非活性
            btn: [
                { element_id: '001', element_name: '変更', isActive: true },
                { element_id: '002', element_name: '削除', isActive: true },
                { element_id: '003', element_name: '追加', isActive: true },
                { element_id: '004', element_name: '検索', isActive: true }
            ],
            vue_id: 'SCR0109',
            rules: {
                string_type: value => validater.checkDateStringType(value) || this.$t('error.validation.num'),
                format_date: value => validater.checkDateFormat(value) || this.$t('error.validation.date.Correct'),
                correct_date: value => validater.checkCorrectDate(value) || this.$t('error.validation.date.Correct')
            }
        };
    },
    async created () {
        await this.$apollo.mutate({
            mutation: GET_LOGIN_ADMIN
        }).then(res => {
            this.admin.user_id = res.data.getLoginAdmin.user_id;
            this.admin.user_div = res.data.getLoginAdmin.login.user_div;
            this.admin.golf_code = res.data.getLoginAdmin.login.golf_code;
            return res.data.getLoginAdmin;
        });
        await this.initialFetch();

        this.admin.point_use_type = this.golf_groups[0].point_use_type;

        // システム管理者の場合
        if (this.admin.user_div === 1) {
            this.Itemlist = [];
            this.Itemlist = this.golfSelect;
            this.golf_code = this.Itemlist[0].golf_code;
        } else {
        // ゴルフ場担当者
            this.Itemlist = [];
            this.Itemlist.push(this.golfSelect.find(el => el.golf_code === this.admin.golf_code));
            this.golf_code = this.admin.golf_code;
        }
        await this.getAuthorityByMemberList();
        await this.getDeliveryMessageList();
    },
    computed: {
        formatedDate: function () {
            return function (pdate) {
                pdate = this.addHyphen(pdate);
                return pdate;
            };
        }
    },
    methods: {
        initialFetch () {
            return this.$apollo.mutate({
                mutation: MEMBER_LIST_INITIAL_DISPLAY,
                variables: {
                    golf_group_code: process.env.VUE_APP_GROUP_CODE
                }
            }).then(res => {
                this.golfSelect = res.data.getGolfCourse;
                if (this.golfSelect.length === 1) {
                    this.golfCount = 0;
                } else {
                    this.golfCount = 1;
                }
                this.golf_groups = res.data.getGolfGroupByMaster;
            });
        },
        getAuthorityByMemberList () {
            this.$apollo.mutate({
                mutation: GET_OPERATION_ACCESSES_LIST,
                variables: {
                    golf_group_code: process.env.VUE_APP_GROUP_CODE,
                    user_id: this.admin.user_id,
                    vue_id: this.vue_id,
                    element_id: ''
                }
            }).then(res => {
                let opeList = res.data.GetOperationAccessList.OperationAccessList;
                for (let list of opeList) {
                    this.btn.forEach(el => {
                        if (list.element_id === el.element_id) {
                            if (list.element_control === 0) {
                                el.isActive = true;
                            } else {
                                el.isActive = false;
                            }
                        }
                    });
                };
            });
        },
        /** --------------------------------------------
        * 検索ボタン押下時
        * -------------------------------------------- */
        async clickSearch () {
            await this.getDeliveryMessageList();
        },
        /** --------------------------------------------
        * 連絡事項設定一覧取得
        * -------------------------------------------- */
        async getDeliveryMessageList () {
            try {
                await this.$apollo
                    .mutate({
                        fetchPolicy: 'no-cache',
                        mutation: GET_MESSAGE_DELIVERY_LIST,
                        variables: {
                            golf_code: this.golf_code,
                            begin_row: this.begin_row,
                            limit_rows: this.limit_rows
                        }
                    })
                    .then(res => {
                        this.desserts = [];
                        this.desserts = res.data.GetMessageDeliveryList.MessageDeliveryList;
                        this.pageCount = Math.ceil(res.data.GetMessageDeliveryList.count / this.limit_rows);
                    });
            } catch (error) {
                this.error = error;
            }
        },
        /** ----------------------------------------------
         * 削除
         * ---------------------------------------------- */
        deleteMessage: async function () {
            try {
                await this.$apollo.mutate({
                    mutation: DELETE_MESSAGE_DELIVERY,
                    variables: {
                        id: this.fromSetData.id
                    }
                }).then(res => {
                    this.process.result = '1';
                    this.process.resultText = this.$t('result.success.remove');
                    this.getDeliveryMessageList();
                });
            } catch (error) {
                this.process.result = '1';
                this.process.resultText = this.$t('result.error.remove');
                this.error = error;
            }
        },
        /** ----------------------------------------------
         * コードリスト取得
         * ---------------------------------------------- */
        getCodeList (keyname) {
            return this.$apollo.query({
                query: GET_CODE_LIST,
                variables: {
                    code_key: keyname,
                    default_display: 0
                }
            }).then(res => {
                return res.data.GetCodeList.CodeList;
            });
        },
        /** ----------------------------------------------
        * 追加ボタン押下時の処理
        * @item 子画面に渡すモーダル表示制御値
        * ---------------------------------------------- */
        OnAddModal: function (item) {
            this.$refs.MessageModal.OpenModal(item);
        },
        /** ----------------------------------------------
        * 変更ボタン押下時の処理
        * @item 子画面に渡すモーダル表示制御値
        * ---------------------------------------------- */
        OnEditModal: function (item) {
            this.$refs.MessageModal.OpenModal(item);
        },
        /** ----------------------------------------------
        * 変更ボタン押下時の処理
        * @item 子画面に渡すモーダル表示制御値
        * ---------------------------------------------- */
        OnCloseEditModal: function (item) {
            this.getDeliveryMessageList();
        },
        /** ----------------------------------------------
        * 削除ボタン押下時の処理
        * @item 子画面に渡すモーダル表示制御値
        * ---------------------------------------------- */
        OnDeleteModal: function (item) {
            this.deleteOverlay = !this.deleteOverlay;
            this.fromSetData.id = item.id;
        },
        clickPagination: function () {
            this.begin_row = this.page * this.limit_rows - this.limit_rows;
            this.getDeliveryMessageList();
        }
    }
};
</script>

<style scoped>
.point_select {
  color: black;
  background: Transparent;
  text-decoration: underline;
}

.selectWidth {
    width: 195px;
}

</style>
